import { slideMainText } from "../../styles/typography.css";
import { TextLink } from "../link/TextLink";
import { container } from "./styles.css";

export const LoadingFailed = () => {
  return (
    <div className={container}>
      <span className={slideMainText.default}>
        It looks like you're offline.
        <br />
        Please check your internet
        <br />
        and{" "}
        <TextLink isExternal sameTab to="/">
          try again
        </TextLink>
      </span>
    </div>
  );
};
